<template>
	<div class="">
		<drawer
			:title="addEditTitle"
			:dialogShow="addEditShow"
			@handleChange="handleChangeDrawer"
		>
			<div slot="body">
				<p class="order-title-boxs">
					<span class="blueBlock"></span><i>基本信息</i>
				</p>
				<div class="pay-mains">
					<div class="totals-box pl24 mt20">
						<div class="flex-row mb30">
							<div class="itemName">客户姓名</div>
							<div class="itemNum jishi">
								{{ form.memberName }}
							</div>
						</div>
						<div class="flex-row mb30">
							<div class="itemName">手机号码</div>
							<div class="itemNum">{{ form.mobile }}</div>
						</div>
						<div class="flex-row mb30">
							<div class="itemName">套餐</div>
							<div class="itemNum">{{ form.cardName }}</div>
						</div>
						<div class="flex-row mb30">
							<div class="itemName">剩余天数</div>
							<div class="itemNum" v-if="form.validDay != -1">
								{{
									form.validDay == 0
										? '已过期'
										: form.validDay
								}}
							</div>
							<div class="itemNum" v-else>永久有效</div>
						</div>
						<div class="flex-row mb30">
							<div class="itemName">剩余次数</div>
							<div class="itemNum">{{ form.leftCount }}</div>
						</div>
						<div class="flex-row mb30">
							<div class="itemName">有效次数</div>
							<div class="itemNum">{{ form.originNum }}</div>
						</div>
						<div class="flex-row mb30" v-if="form.validDay != -1">
							<div class="itemName">有效时间</div>
							<div class="itemNum">{{ form.validEndTime }}</div>
						</div>
						<div class="flex-row mb30">
							<div class="itemName">最后消费时间</div>
							<div class="itemNum">{{ form.lastTradeTime }}</div>
						</div>
					</div>
				</div>
				<p class="order-title-boxs">
					<span class="blueBlock"></span><i>消费记录</i>
				</p>
				<div class="plr16">
					<el-table
						:data="form.consumeList"
						:max-height="height - 210"
						header-cell-class-name="table_header_bgcolor"
					>
						<el-table-column
							:align="item.align"
							:label="item.label"
							:width="item.width"
							:min-width="item.minWidth"
							:show-overflow-tooltip="false"
							v-for="(item, index) in columns"
							:key="index"
						>
							<template slot-scope="scope">
								{{
									Boolean(item.formatDay)
										? formatDay(scope.row[index])
										: scope.row[index]
								}}
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="drawer-footer">
					<el-button @click="handleChangeDrawer">返回</el-button>
				</div>
			</div>
		</drawer>
	</div>
</template>

<script>
import minxin from '../../../assets/javascript/minxin.js'
import drawer from '../../../components/common/drawer'
import config from './config/columns'
export default {
	mixins: [minxin],
	components: { drawer },
	data() {
		return {
			addEditTitle: '',
			addEditShow: false,
			form: {
				mobile: '',
				gender: 'male',
				nextRepairTime: '',
				recordTime: '',
			},
			columns: config.detail,
			staffList: [],
			cardOldName: '',
			height: '',
		}
	},
	created() {
		this.editInit()
	},
	methods: {
		editInit() {
			this.$on('set', function(org) {
				Object.assign(this.$data, this.$options.data())
				this.addEditTitle = '电子套餐详情';
        this.height = this.$store.getters.MainHeight;
				this.$api
					.get(this.$url.packageManagement.get, {
						id: org.id,
					})
					.then((res) => {
						if (res) {
							this.form = res
							this.form.validEndTime = this.formatDay(
								this.form.validEndTime
							)
						}
					})
					.catch((error) => {})
				this.addEditShow = true
			})
		},
		handleChangeDrawer() {
			this.addEditShow = false
			this.$emit('change', false)
		},
		onSubmit(values) {
			this.addEditShow = false
		},
	},
}
</script>
